/* eslint-disable */
import {
  getDivs,
  getStyles,
  getScripts,
  getScriptsFromRawHtml,
  getStylesFromRawHtml,
  removeStyles,
  removeScripts,
  tagId
} from '../../shared/utils/html.utils';

// import type { ParsedStyle, ParsedScript } from '@/utils/html.utils';

// export type AdvType = 'unknown' | 'yandex-rtb' | 'dfp' | 'dfp-prebid';

// export type Adv = {
//   type: AdvType,
//   sourceContent: string
// } & ParsedAdvContent;

// export type ParsedAdvContent = {
//   containerId?: string | null,
//   html?: string,
//   style?: ParsedStyle | null,
//   script?: ParsedScript | null
// };

export class AdvService {
  /**
   * Определяем тип рекламы и возвращаем распарсенный объект,
   * чтобы можно было проинициализировать рекламу в зависимости от типа
   * @param {string} advContent - контент рекламного блока (content);
   * виды advContent можно посмотреть в jtn-widget-adv/README.md
   */
  processAdvContent(advContent) /* : Adv */ {
    let type /* : AdvType */ = 'unknown';
    let adv /* : Adv */ = {
      type,
      sourceContent: advContent,
      script: '',
      containerId: '',
      html: '',
      style: '',
    };

    if (advContent.indexOf('Ya.Context.AdvManager') !== -1) {
      type = 'yandex-rtb';
    }

    if (advContent.indexOf('div-gpt-ad') !== -1) {
      type = 'dfp';
    }

    if (advContent.indexOf('data-prebid') !== -1) {
      type = 'dfp-prebid';
    }

    if (advContent.indexOf('adfox_') !== -1) {
      type = 'adfox';
    }

    adv = { ...adv, type, ...this._getParsedAdvContent(advContent, type) };

    return adv;
  }

  _getParsedAdvContent(
    advContent /* : string */,
    advType /* : AdvType */
  ) /* : ParsedAdvContent */ {
    let containerId = '';
    let html = '';
    const style = this._getAdvStyle(advContent);
    const script = this._getAdvScript(advContent);

    // для 'yandex-rtb' нужно по-другому сформировать html,
    // потому что там бывают div вложенный в div
    // в <div class="ya-custom"> вложен div с id
    // (см. jtn-widget-adv/README.md)
    if (advType === 'yandex-rtb') {
      html = removeStyles(removeScripts(advContent));
    } else {
      html = this._getAdvHtml(advContent);
    }

    containerId = tagId(html);

    return {
      containerId,
      html,
      style,
      script
    };
  }

  /**
   * Выгребаем div-тег из контента рекламы.
   * Обычно div с id, чтобы уже сторонний рекламный скрипт
   * проинициализировал рекламу на месте этого div'a по id
   * @param {string} advContent
   */
  _getAdvHtml(advContent /* : string */) {
    const divs = getDivs(advContent);
    return divs !== null && divs.length > 0 ? divs[0] : '';
  }

  /**
   * Получаем style
   * @param {string} advContent
   */
  _getAdvStyle(advContent /* : string */) /* : ParsedStyle | null */ {
    const styles = getStyles(advContent);
    let style = null;

    if (styles !== null && styles.length > 0) {
      const parsedStyles = getStylesFromRawHtml(styles[0]);
      if (parsedStyles && parsedStyles.length > 0) {
        style = parsedStyles[0];
      }
    }

    return style;
  }

  /**
   * Получаем сторонний script, который будет запускаться, чтобы
   * реклама проинициализировалась
   * @param {string} advContent
   */
  _getAdvScript(advContent /* : string */) /* : ParsedScript | null */ {
    const scripts = getScripts(advContent);
    let script = null;

    if (scripts !== null && scripts.length > 0) {
      const parsedScripts = getScriptsFromRawHtml(scripts[0]);
      if (parsedScripts && parsedScripts.length > 0) {
        script = parsedScripts[0];
      }
    }

    return script;
  }
}

export const advService = new AdvService();
